import { useEffect, useRef, useState, useCallback } from 'react';

import KUTE from 'kute.js';
import { ReactComponent as LogoSVG } from '../Images/header/logo.svg';
export default function Resize({}) {
  const [isResizing, setIsResizing] = useState(false);
  const startTime = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    window.onresize = resizeWindow;
  }, []);

  function resizeWindow() {
    startTime.current = new Date();

    setIsResizing(true);

    setTimeout(() => {
      let currentTime = new Date();

      let pastTime = currentTime - startTime.current;

      if (pastTime > 400) {
        if (boxRef.current == null) {
          return;
        }
        let kute = KUTE.to(
          '#resizingBox',
          { opacity: '0' },
          {
            duration: 100,
            onComplete: () => {
              //アニメーション終了あと
              setIsResizing(false);
            },
          },
        );
        kute.start();
      }
    }, 500);
  }

  return (
    <>
      {isResizing && (
        <div ref={boxRef} id="resizingBox">
          <LogoSVG />
        </div>
      )}
    </>
  );
}
